


















// @ts-nocheck
import { Component, Vue, Watch } from 'vue-property-decorator'
import { DataStore, SortDirection, Hub } from 'aws-amplify'
import { query as tenant } from '@/store/tenant'
import { Page } from '../models/index'

@Component<ChecklistsSideBar>({
  apollo: {
    tenant
  }
})
export default class ChecklistsSideBar extends Vue {
  pages = []
  pagesSubscription = null

  @Watch('tenant')
  async recreate() {
    this.subscribeToPages();
  }

  subscribeToPages() {
    if (!this.tenant) return;
    this.pagesSubscription?.unsubscribe()
    this.pagesSubscription = DataStore.observeQuery(
      Page,
      p => p.tenant.eq(this.tenant.id),
      {
        sort: s => s.sortPosition(SortDirection.ASCENDING)
      }
    ).subscribe(({ items }) => {
      this.pages = Array.from(items)
    })
  }
  created() {
    this.subscribeToPages()
    Hub.listen('ListEdit', ({ payload }) => {
      if (payload.data?.model === 'Page') {
        this.subscribeToPages()
      }
    })
  }
  destroyed() {
    this.pagesSubscription.unsubscribe()
    Hub.remove('ListEdit', () => {})
  }

  get pageSelected() {
    return Boolean(this.$route.params.pageId)
  }
}
